import { Link } from "react-router-dom";
import Logo from "./Logo";

const friendLinks = [
  { label: "影视资讯", to: "/search" },
  { label: "电影分类", to: "/category/movie" },
  { label: "电视剧分类", to: "/category/tv" },
  { label: "关于我们", to: "/about" },
];

export default function Footer() {
  return (
    <footer className="w-full bg-primary-950 text-background-200">
      <div className="w-full px-4 md:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          <div>
            <Logo variant="light" />
            <p className="mt-4 text-sm leading-6 text-background-300/80 max-w-sm">
              天天影院专注最新热门电影与电视剧，提供剧情介绍、影片推荐与影视资讯，帮助你轻松发现优质影视内容。
            </p>
          </div>

          <div>
            <h4 className="text-background-50 font-heading text-base mb-4">
              <a href="#footer-nav" className="cursor-pointer">站内导航</a>
            </h4>
            <ul className="grid grid-cols-2 gap-3 text-sm" id="footer-nav">
              {friendLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-background-300/80 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-background-50 font-heading text-base mb-4">
              <a href="#footer-contact" className="cursor-pointer">联系我们</a>
            </h4>
            <ul className="space-y-3 text-sm text-background-300/80" id="footer-contact">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-400" />
                contact@tiantiancinema.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-wechat-line text-accent-400" />
                微信公众号：天天影院
              </li>
            </ul>
            <div className="mt-4 flex items-center gap-3">
              <a
                href="https://destv.cn"
                target="_blank"
                rel="noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-900 text-background-100 hover:bg-accent-500 hover:text-background-950 transition-colors cursor-pointer"
                aria-label="微博"
              >
                <i className="ri-weibo-fill" />
              </a>
              <a
                href="https://www.bilibili.com"
                target="_blank"
                rel="noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-900 text-background-100 hover:bg-accent-500 hover:text-background-950 transition-colors cursor-pointer"
                aria-label="哔哩哔哩"
              >
                <i className="ri-bilibili-fill" />
              </a>
              <a
                href="https://www.youtube.com"
                target="_blank"
                rel="noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-900 text-background-100 hover:bg-accent-500 hover:text-background-950 transition-colors cursor-pointer"
                aria-label="YouTube"
              >
                <i className="ri-youtube-fill" />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-800 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-400/70">
          <p>© 2026 天天影院 TianTian Cinema. 保留所有权利。</p>
          <p>本站影视内容均为虚构演示，不含真实播放与下载功能。</p>
        </div>
      </div>
    </footer>
  );
}